import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { MandatesStatusFilterPipe } from '../core/pipes/mandates-status-filter.pipe';
import { MaterialModule } from '../material.module';
import { MatRippleModule } from '@angular/material/core';
import { BaseDialog } from './components/base-dialog/base-dialog';
import { BaseFilterComponent } from './components/base-filter/base-filter.component';
import { ClientCardComponent } from './components/client-card/client-card.component';
import { ClientIconComponent } from './components/client-icon/client-icon.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { MainToolbarComponent } from './components/main-toolbar/main-toolbar.component';
import { MandateSignerCardComponent } from './components/mandate-signer-card/mandate-signer-card.component';
import { ReturnButtonComponent } from './components/return-button/return-button.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { FilterButtonFormComponent } from './components/base-filter/filter-button-form/filter-button-form.component';
import { DropzoneUploadComponent } from './components/dropzone-upload/dropzone-upload.component';
import { OutsideClickDirective } from '../core/directives/outside-click.directive';
import { TableComponent } from './components/table/table.component';
import { BaseBannerComponent } from './components/banners/base-banner/base-banner.component';
import { ApproveMandatesBannerComponent } from './components/banners/approve-mandates-banner/approve-mandates-banner.component';
import { LetDirective } from './directives/let.directive';
import { CollapsableComponent } from './components/collapsable/collapsable.component';
import { StripHtmlPipe } from './pipes/strip-html.pipe';

@NgModule({
  declarations: [
    SidenavComponent,
    MainToolbarComponent,
    BaseDialog,
    InputFieldComponent,
    ClientIconComponent,
    ReturnButtonComponent,
    ClientCardComponent,
    MandatesStatusFilterPipe,
    MandateSignerCardComponent,
    BaseFilterComponent,
    FilterButtonFormComponent,
    DropzoneUploadComponent,
    OutsideClickDirective,
    TableComponent,
    BaseBannerComponent,
    ApproveMandatesBannerComponent,
    CollapsableComponent,
    StripHtmlPipe,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    LayoutModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DigitOnlyModule,
    MatRippleModule,
    LetDirective,
  ],
  exports: [
    MaterialModule,
    SidenavComponent,
    TranslateModule,
    InputFieldComponent,
    ClientIconComponent,
    ReturnButtonComponent,
    ClientCardComponent,
    MandatesStatusFilterPipe,
    FormsModule,
    ReactiveFormsModule,
    MandateSignerCardComponent,
    BaseFilterComponent,
    DropzoneUploadComponent,
    OutsideClickDirective,
    TableComponent,
    BaseBannerComponent,
    ApproveMandatesBannerComponent,
    LetDirective,
    CollapsableComponent,
    StripHtmlPipe,
  ],
})
export class SharedModule {}
